import { model as router } from '!/router'
import { useUnit } from 'effector-react'
import type { JSX } from 'react'
import { useTranslation } from 'react-i18next'
import { AuthLayout } from '~/widgets/auth'
import { FinalMessage } from '../../shared/ui'
import { AppTitle } from '~/shared/ui/components/AppTitle'

export function Title(): JSX.Element {
  return <AppTitle t={['sign_up', 'fail']} />
}

FailPage.displayName = 'FailPage'
export function FailPage(): JSX.Element {
  const { t } = useTranslation()
  const reason = t(
    (useUnit(router.$state) as string) || 'something_went_wrong_error'
  )

  return (
    <AuthLayout>
      <FinalMessage
        title={t('sorry')}
        body={t('confirm_fail_message', {
          reason,
        })}
        button={t('sign_up')}
        to='/sign-up'
      />
    </AuthLayout>
  )
}
